module.exports = __webpack_public_path__ + "media/images/map/map-marker-flat-f3696b2b0bca9d6c044d3f11598331e2.png";